import {defineMessages} from 'react-intl';

export default defineMessages({
    jobTitle: {id: 'app.pages.user.candidateRelevanceModal.jobTitle'},
    startDate: {id: 'app.pages.user.candidateRelevanceModal.workExperience.date.startDate'},
    endDate: {id: 'app.pages.user.candidateRelevanceModal.workExperience.date.endDate'},
    companyName: {id: 'app.pages.user.candidateRelevanceModal.workExperience.company'},
    description: {id: 'app.pages.user.candidateRelevanceModal.workExperience.description'},
    removeButtonText: {id: 'app.pages.user.candidateRelevanceModal.remove'},
    removeExperienceTitle: {
        id: 'app.jobRecommandations.workExperience.removeExperienceAlert.remove'
    },
    removeExperienceDescription: {
        id: 'app.jobRecommandations.workExperience.removeExperienceAlert.description'
    },
    cancel: {id: 'app.general.cancel'},
    present: {id: 'app.pages.user.candidateRelevanceModal.workExperience.date.present'}
});

export const monthMessages = defineMessages({
    1: {id: 'app.general.date.january'},
    2: {id: 'app.general.date.february'},
    3: {id: 'app.general.date.march'},
    4: {id: 'app.general.date.april'},
    5: {id: 'app.general.date.may'},
    6: {id: 'app.general.date.june'},
    7: {id: 'app.general.date.july'},
    8: {id: 'app.general.date.august'},
    9: {id: 'app.general.date.september'},
    10: {id: 'app.general.date.october'},
    11: {id: 'app.general.date.november'},
    12: {id: 'app.general.date.december'}
});
